import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import Category from "@/pcm/store/models/Category";
import Tag from "@/pcm/store/models/Tag";
import Contract from "@/pcm/store/models/Contract";
import Network from "@/pcm/store/models/Network";
import Company from "@/pcm/store/models/Company";

export default class Media extends Model {
    static entity = 'media_view';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'name',
    };

    static fields() {
        return {
            id: this.uid(),
            media_id: this.uid(),
            amount: this.string(''),

            created_at: this.string(''),
            updated_at: this.string(''),

            media: this.attr(null),
        }
    }

    declare id: number;
    declare media_id: number;
    declare amount: string;

    declare media: Media;
}
